Vue.component('activity-graph', {
    props: ['activity-data'],

    template: `<div style="position: relative;"><canvas class="chart" id="activity-chart" height="400px;"></canvas></div>`,

    mounted () {
        this.render();
    },

    methods: {
        render() {
            var acLabels = [];
            var acData = [
                [],
                [],
                [],
                [],
                [],
                [],
                []
            ];

            // Activity Labels
            $.each(this.activityData.labels, function (key, value) {
                acLabels.push(value);
            });

            // Sort Email
            $.each(this.activityData.Email, function (key, value) {
                acData[1].push(value);
            });

            // Sort Notes
            $.each(this.activityData.Note, function (key, value) {
                acData[2].push(value);
            });

            // Sort LinkedIn
            $.each(this.activityData.LinkedIn, function (key, value) {
                acData[3].push(value);
            });

            // Sort Call Report
            $.each(this.activityData.Report, function (key, value) {
                acData[4].push(value);
            });

            // Sort Prospects
            $.each(this.activityData.Prospects, function (key, value) {
                acData[5].push(value);
            });

            // Sort Sales
            $.each(this.activityData.Sales, function (key, value) {
                acData[6].push(value);
            });

            var mainChart = new Chart($('#activity-chart'), {
                responsive: true,
                type: 'line',
                data: {
                    labels: acLabels,
                    datasets: [{
                        label: 'Calls Activity',
                        backgroundColor: 'transparent',
                        borderColor: getStyle('--danger'),
                        pointHoverBackgroundColor: '#fff',
                        borderWidth: 2,
                        data: acData[4]
                    }, {
                        label: 'Emails Activity',
                        backgroundColor: 'transparent',
                        borderColor: getStyle('--success'),
                        pointHoverBackgroundColor: '#fff',
                        borderWidth: 2,
                        data: acData[1]
                    }, {
                        label: 'Notes Activity',
                        backgroundColor: 'transparent',
                        borderColor: getStyle('--secondary'),
                        pointHoverBackgroundColor: '#fff',
                        borderWidth: 2,
                        data: acData[2]
                    }, {
                        label: 'LinkedIn Activity',
                        backgroundColor: 'transparent',
                        borderColor: getStyle('--info'),
                        pointHoverBackgroundColor: '#fff',
                        borderWidth: 2,
                        data: acData[3]
                    }, {
                        label: 'Prospects',
                        backgroundColor: 'transparent',
                        borderColor: getStyle('--warning'),
                        pointHoverBackgroundColor: '#fff',
                        borderWidth: 2,
                        borderDash: [8, 5],
                        data: acData[5]
                    }, {
                        label: 'Sales',
                        backgroundColor: hexToRgba(getStyle('--info'), 10),
                        borderColor: getStyle('--info'),
                        pointHoverBackgroundColor: '#fff',
                        borderWidth: 2,
                        data: acData[6]
                    }]
                },
                options: {
                    maintainAspectRatio: true,
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                maxTicksLimit: this.activityData.max,
                                stepSize: Math.round(this.activityData.max / 10),
                                // max: this.activityData.max
                            }
                        }]
                    },
                    elements: {
                        point: {
                            radius: 0,
                            hitRadius: 10,
                            hoverRadius: 4,
                            hoverBorderWidth: 3
                        }
                    }
                }
            });
        }
    },

    watch: {
        activityData () {
            this.render();
        }
    }
});